'use client';

import { useEffect } from 'react';

import { apiClient } from '@/lib/api/client';

type CustomLogosResponse = {
  status: string;
  logos?: string[];
};

function applyCustomLogos(logos: string[]) {
  if (logos.length === 0) {
    return;
  }

  const logoElements = document.querySelectorAll<HTMLImageElement>(
    '.top-logo, .top-logo-mobile, .footer_pro_menu_logo img',
  );

  logoElements.forEach((element, index) => {
    const logo = logos[index % logos.length];
    if (logo) {
      element.src = logo;
    }
  });
}

export function useCustomLogos() {
  useEffect(() => {
    let cancelled = false;

    async function loadLogos() {
      try {
        const { data } = await apiClient.post<CustomLogosResponse>(
          '/pro/custom/logos',
          {},
        );
        if (!cancelled && data.status === 'success' && data.logos?.length) {
          applyCustomLogos(data.logos);
        }
      } catch {
        // Optional branding enhancement — ignore failures.
      }
    }

    void loadLogos();

    return () => {
      cancelled = true;
    };
  }, []);
}
